declare type DomElements = {
  [key: string]: HTMLElement | NodeListOf<HTMLElement> | null;
};

class AchievementsModule {
  maxInitialCards: number | undefined;
  dom?: DomElements;

  constructor(protected el: HTMLElement) {
    this.maxInitialCards = 6;
    this.setupDefaults();
    this.addListeners();
  }

  setupDefaults() {
    this.dom = {
      cardsInner: this.el.querySelector<HTMLElement>(
        '.achievements-module__cards'
      ),
      cardsContainer: this.el.querySelector<HTMLElement>(
        '.achievements-module__cards-container'
      ),
      cards: this.el.querySelectorAll<HTMLElement>('.achievements-card'),
      cta: this.el.querySelector<HTMLElement>('.btn')
    };

    const cardsContainer = this.dom.cardsContainer as HTMLElement;

    this.hideCards(this.maxInitialCards);
    this.hideCTA(this.maxInitialCards);
    cardsContainer.style.overflowY = 'clip';
  }

  addListeners() {
    (this.dom?.cta as Node)?.addEventListener(
      'click',
      this.handleCtaClick.bind(this)
    );
  }

  hideCards(maxInitialCards: number | undefined) {
    const cards = this.dom?.cards as NodeListOf<HTMLElement>;
    if (!cards) return;

    cards.forEach((card, index) => {
      if (maxInitialCards && index + 1 > maxInitialCards) {
        card.style.display = 'none';
      }
    });
  }

  hideCTA(maxInitialCards: number | undefined) {
    const cards = this.dom?.cards as NodeListOf<HTMLElement>;
    if (!cards) return;

    if (maxInitialCards && cards.length <= maxInitialCards) {
      (this.dom?.cta as HTMLElement).style.display = 'none';
    }
  }

  handleCtaClick() {
    const cards = this.dom?.cards as NodeListOf<HTMLElement>;
    const cardsInner = this.dom?.cardsInner as HTMLElement;
    const cardsContainer = this.dom?.cardsContainer as HTMLElement;
    if (!cards || !cardsInner || !cardsContainer) return;

    (this.dom?.cta as HTMLElement).style.display = 'none';
    cardsContainer.style.height = cardsInner.offsetHeight + 'px';
    for (const card of cards) {
      card.style.display = 'block';
    }
    cardsContainer.style.height = cardsInner.offsetHeight + 'px';
    setTimeout(() => {
      cardsContainer.style.height = 'auto';
    }, 1200);
  }
}

export default AchievementsModule;
